function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.16797 13.0013H10.8346V14.668H9.16797V13.0013ZM9.16797 6.33464H10.8346V11.3346H9.16797V6.33464ZM9.99297 2.16797C5.39297 2.16797 1.66797 5.9013 1.66797 10.5013C1.66797 15.1013 5.39297 18.8346 9.99297 18.8346C14.6013 18.8346 18.3346 15.1013 18.3346 10.5013C18.3346 5.9013 14.6013 2.16797 9.99297 2.16797ZM10.0013 17.168C6.31797 17.168 3.33464 14.1846 3.33464 10.5013C3.33464 6.81797 6.31797 3.83464 10.0013 3.83464C13.6846 3.83464 16.668 6.81797 16.668 10.5013C16.668 14.1846 13.6846 17.168 10.0013 17.168Z",
  fill: "#D31759"
});

function SvgWarningOutline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningOutline);
export default __webpack_public_path__ + "static/media/warning-outline.7f1bfb6f.svg";
export { ForwardRef as ReactComponent };